import React from 'react';
import {Dimensions} from 'react-native';

import {Constants} from '../../constants';

const {GALAXY_S8, GALAXY_S10} = Constants.SCREEN_HEIGHT;

export const useBreakpoints = () => {
  const {height} = Dimensions.get('window');

  return React.useMemo(
    () => ({
      isSmall: height <= GALAXY_S8,
      isMedium: height <= GALAXY_S10,
      screenHeight: height,
    }),
    [height],
  );
};
